import React from 'react';

import { useGetParametersForView } from 'security-app/hooks/useEventProceduresAPI';
import { FormikInput, Spinner } from 'components/common';
import { Col } from 'security-app/components/common/FormBaseStyles';

type Props = {
  viewType: string;
  readOnly: boolean;
  viewId?: string;
};

function EventProceduresParametersForm({ viewType, readOnly, viewId = '' }: Props) {
  const { parameters, fetchingParameters } = useGetParametersForView({ viewId, type: viewType });

  if ((!fetchingParameters && !parameters) || parameters?.length < 1) {
    return null;
  }

  return (
    <>
      {fetchingParameters ? (
        <Spinner />
      ) : (
        <>
          <p>
            This {viewType} uses parameters which need to be entered before it can be executed. Please enter the
            parameter values into the form.
          </p>
          {parameters.map((parameter) => {
            const { name, title, optional } = parameter;

            return (
              <Col $fullWidth $width="100%" $gap="0.3rem" $align="stretch" key={`${name}-parameter`}>
                <FormikInput
                  type="text"
                  name={`parameters.${name}`}
                  id={name}
                  label={title}
                  validate={(value) => !optional && !value && 'This parameter is required'}
                  required={!optional}
                  disabled={readOnly}
                />
              </Col>
            );
          })}
        </>
      )}
    </>
  );
}

export default EventProceduresParametersForm;
